const translations = {
  tr: {
    lang: 'tr',
    title: 'Video İndirici',
    subtitle: 'YouTube, Twitter, Instagram, TikTok ve Facebook videolarını HD kalitede ücretsiz indirin',
    pasteUrl: 'Video bağlantısını buraya yapıştırın...',
    paste: 'Yapıştır',
    download: 'İndir',
    loading: 'Yükleniyor...',
    heroText: 'YouTube, Twitter, Instagram, TikTok ve Facebook\'tan ücretsiz video indirin.',
    seoTitle: 'Ücretsiz Online Video İndirici',
    seoDesc: 'HD Video Download, favori platformlarınızdan video indirmenin en kolay yoludur. YouTube videolarını 4K kalitede, Twitter videolarını ve GIF\'leri, Instagram Reels, TikTok videolarını filigramsız ve Facebook videolarını ücretsiz indirin.',
    feature1Title: 'Çoklu Format',
    feature1Desc: 'MP4 video veya MP3 ses olarak indirin. 240p\'den 4K kaliteye kadar seçin.',
    feature2Title: 'Kurulum Gereksiz',
    feature2Desc: 'Doğrudan tarayıcınızda çalışır. Yazılım veya eklenti gerekmez.',
    feature3Title: 'Tüm Cihazlar',
    feature3Desc: 'Windows, Mac, iPhone, Android ve tarayıcısı olan her cihazda çalışır.',
    howTo: 'Nasıl İndirilir',
    faq: 'SSS',
    metaDesc: 'YouTube, Twitter, Instagram, TikTok ve Facebook videolarını HD kalitede ücretsiz indirin. MP4, MP3 formatlarında 4K\'ya kadar video indirme aracı.',
  },
  es: {
    lang: 'es',
    title: 'Descargador de Videos',
    subtitle: 'Descarga videos de YouTube, Twitter, Instagram, TikTok y Facebook en HD gratis',
    pasteUrl: 'Pega la URL del video aquí...',
    paste: 'Pegar',
    download: 'Descargar',
    loading: 'Cargando...',
    heroText: 'Descarga videos de YouTube, Twitter, Instagram, TikTok y Facebook gratis.',
    seoTitle: 'Descargador de Videos Online Gratis',
    seoDesc: 'HD Video Download es la forma más fácil de descargar videos de tus plataformas favoritas. Guarda videos de YouTube en calidad HD hasta 4K, descarga videos de Twitter y GIFs, Instagram Reels, videos de TikTok sin marca de agua y videos de Facebook — todo gratis.',
    feature1Title: 'Múltiples Formatos',
    feature1Desc: 'Descarga en video MP4 o audio MP3. Elige desde 240p hasta calidad 4K.',
    feature2Title: 'Sin Instalación',
    feature2Desc: 'Funciona directamente en tu navegador. No necesitas software ni extensiones.',
    feature3Title: 'Todos los Dispositivos',
    feature3Desc: 'Funciona en Windows, Mac, iPhone, Android y cualquier dispositivo con navegador.',
    howTo: 'Cómo Descargar',
    faq: 'Preguntas Frecuentes',
    metaDesc: 'Descarga videos de YouTube, Twitter, Instagram, TikTok y Facebook en calidad HD gratis. Guarda como MP4 o MP3, hasta resolución 4K.',
  },
  fr: {
    lang: 'fr',
    title: 'Téléchargeur de Vidéos',
    subtitle: 'Téléchargez des vidéos YouTube, Twitter, Instagram, TikTok et Facebook en HD gratuitement',
    pasteUrl: 'Collez l\'URL de la vidéo ici...',
    paste: 'Coller',
    download: 'Télécharger',
    loading: 'Chargement...',
    heroText: 'Téléchargez des vidéos de YouTube, Twitter, Instagram, TikTok et Facebook gratuitement.',
    seoTitle: 'Téléchargeur de Vidéos en Ligne Gratuit',
    seoDesc: 'HD Video Download est le moyen le plus simple de télécharger des vidéos de vos plateformes préférées. Enregistrez des vidéos YouTube en qualité HD jusqu\'à 4K, téléchargez des vidéos Twitter et GIFs, Instagram Reels, vidéos TikTok sans filigrane et vidéos Facebook — tout gratuitement.',
    feature1Title: 'Formats Multiples',
    feature1Desc: 'Téléchargez en vidéo MP4 ou audio MP3. Choisissez de 240p à la qualité 4K.',
    feature2Title: 'Aucune Installation',
    feature2Desc: 'Fonctionne directement dans votre navigateur. Aucun logiciel ni extension nécessaire.',
    feature3Title: 'Tous les Appareils',
    feature3Desc: 'Fonctionne sur Windows, Mac, iPhone, Android et tout appareil avec un navigateur.',
    howTo: 'Comment Télécharger',
    faq: 'FAQ',
    metaDesc: 'Téléchargez des vidéos YouTube, Twitter, Instagram, TikTok et Facebook en qualité HD gratuitement. Enregistrez en MP4 ou MP3, jusqu\'à 4K.',
  },
  pt: {
    lang: 'pt',
    title: 'Baixador de Vídeos',
    subtitle: 'Baixe vídeos do YouTube, Twitter, Instagram, TikTok e Facebook em HD grátis',
    pasteUrl: 'Cole a URL do vídeo aqui...',
    paste: 'Colar',
    download: 'Baixar',
    loading: 'Carregando...',
    heroText: 'Baixe vídeos do YouTube, Twitter, Instagram, TikTok e Facebook de graça.',
    seoTitle: 'Baixador de Vídeos Online Grátis',
    seoDesc: 'HD Video Download é a maneira mais fácil de baixar vídeos das suas plataformas favoritas. Salve vídeos do YouTube em qualidade HD até 4K, baixe vídeos do Twitter e GIFs, Instagram Reels, vídeos do TikTok sem marca d\'água e vídeos do Facebook — tudo grátis.',
    feature1Title: 'Múltiplos Formatos',
    feature1Desc: 'Baixe em vídeo MP4 ou áudio MP3. Escolha de 240p até qualidade 4K.',
    feature2Title: 'Sem Instalação',
    feature2Desc: 'Funciona diretamente no seu navegador. Nenhum software ou extensão necessário.',
    feature3Title: 'Todos os Dispositivos',
    feature3Desc: 'Funciona em Windows, Mac, iPhone, Android e qualquer dispositivo com navegador.',
    howTo: 'Como Baixar',
    faq: 'Perguntas Frequentes',
    metaDesc: 'Baixe vídeos do YouTube, Twitter, Instagram, TikTok e Facebook em qualidade HD grátis. Salve como MP4 ou MP3, até resolução 4K.',
  },
  ar: {
    lang: 'ar',
    title: 'تحميل الفيديو',
    subtitle: 'حمّل فيديوهات من يوتيوب، تويتر، إنستغرام، تيك توك وفيسبوك بجودة عالية مجاناً',
    pasteUrl: '...الصق رابط الفيديو هنا',
    paste: 'لصق',
    download: 'تحميل',
    loading: '...جاري التحميل',
    heroText: 'حمّل فيديوهات من يوتيوب، تويتر، إنستغرام، تيك توك وفيسبوك مجاناً.',
    seoTitle: 'أداة تحميل فيديو مجانية على الإنترنت',
    seoDesc: 'HD Video Download هو أسهل طريقة لتحميل الفيديوهات من منصاتك المفضلة. احفظ فيديوهات يوتيوب بجودة HD حتى 4K، حمّل فيديوهات تويتر وصور GIF، إنستغرام ريلز، فيديوهات تيك توك بدون علامة مائية وفيديوهات فيسبوك — كل ذلك مجاناً.',
    feature1Title: 'صيغ متعددة',
    feature1Desc: 'حمّل بصيغة فيديو MP4 أو صوت MP3. اختر من 240p إلى جودة 4K.',
    feature2Title: 'بدون تثبيت',
    feature2Desc: 'يعمل مباشرة في متصفحك. لا حاجة لبرامج أو إضافات.',
    feature3Title: 'جميع الأجهزة',
    feature3Desc: 'يعمل على ويندوز، ماك، آيفون، أندرويد وأي جهاز مع متصفح.',
    howTo: 'كيفية التحميل',
    faq: 'الأسئلة الشائعة',
    metaDesc: 'حمّل فيديوهات من يوتيوب، تويتر، إنستغرام، تيك توك وفيسبوك بجودة عالية مجاناً. احفظ بصيغة MP4 أو MP3، حتى دقة 4K.',
  },
  zh: {
    lang: 'zh',
    title: '视频下载器',
    subtitle: '免费高清下载YouTube、Twitter、Instagram、TikTok和Facebook视频',
    pasteUrl: '在此粘贴视频链接...',
    paste: '粘贴',
    download: '下载',
    loading: '加载中...',
    heroText: '免费从YouTube、Twitter、Instagram、TikTok和Facebook下载视频。',
    seoTitle: '免费在线视频下载器',
    seoDesc: 'HD Video Download是从您喜爱的平台下载视频的最简单方式。以高清4K质量保存YouTube视频，下载Twitter视频和GIF，Instagram Reels，无水印TikTok视频和Facebook视频——全部免费。',
    feature1Title: '多种格式',
    feature1Desc: '以MP4视频或MP3音频格式下载。从240p到4K画质可选。',
    feature2Title: '无需安装',
    feature2Desc: '直接在浏览器中运行。无需软件或扩展。',
    feature3Title: '所有设备',
    feature3Desc: '适用于Windows、Mac、iPhone、Android及任何有浏览器的设备。',
    howTo: '如何下载',
    faq: '常见问题',
    metaDesc: '免费高清下载YouTube、Twitter、Instagram、TikTok和Facebook视频。保存为MP4或MP3，最高4K分辨率。',
  },
  ru: {
    lang: 'ru',
    title: 'Загрузчик Видео',
    subtitle: 'Скачивайте видео с YouTube, Twitter, Instagram, TikTok и Facebook в HD бесплатно',
    pasteUrl: 'Вставьте URL видео сюда...',
    paste: 'Вставить',
    download: 'Скачать',
    loading: 'Загрузка...',
    heroText: 'Скачивайте видео с YouTube, Twitter, Instagram, TikTok и Facebook бесплатно.',
    seoTitle: 'Бесплатный Онлайн Загрузчик Видео',
    seoDesc: 'HD Video Download — самый простой способ скачать видео с ваших любимых платформ. Сохраняйте видео YouTube в HD качестве до 4K, скачивайте видео Twitter и GIF, Instagram Reels, видео TikTok без водяного знака и видео Facebook — всё бесплатно.',
    feature1Title: 'Множество Форматов',
    feature1Desc: 'Скачивайте в формате видео MP4 или аудио MP3. Выбирайте от 240p до качества 4K.',
    feature2Title: 'Без Установки',
    feature2Desc: 'Работает прямо в браузере. Не нужно устанавливать программы или расширения.',
    feature3Title: 'Все Устройства',
    feature3Desc: 'Работает на Windows, Mac, iPhone, Android и любом устройстве с браузером.',
    howTo: 'Как Скачать',
    faq: 'Частые Вопросы',
    metaDesc: 'Скачивайте видео с YouTube, Twitter, Instagram, TikTok и Facebook в HD качестве бесплатно. Сохраняйте в MP4 или MP3, до разрешения 4K.',
  },
  id: {
    lang: 'id',
    title: 'Pengunduh Video',
    subtitle: 'Unduh video dari YouTube, Twitter, Instagram, TikTok dan Facebook dalam HD gratis',
    pasteUrl: 'Tempel URL video di sini...',
    paste: 'Tempel',
    download: 'Unduh',
    loading: 'Memuat...',
    heroText: 'Unduh video dari YouTube, Twitter, Instagram, TikTok dan Facebook secara gratis.',
    seoTitle: 'Pengunduh Video Online Gratis',
    seoDesc: 'HD Video Download adalah cara termudah untuk mengunduh video dari platform favorit Anda. Simpan video YouTube dalam kualitas HD hingga 4K, unduh video Twitter dan GIF, Instagram Reels, video TikTok tanpa watermark dan video Facebook — semuanya gratis.',
    feature1Title: 'Berbagai Format',
    feature1Desc: 'Unduh dalam format video MP4 atau audio MP3. Pilih dari 240p hingga kualitas 4K.',
    feature2Title: 'Tanpa Instalasi',
    feature2Desc: 'Bekerja langsung di browser Anda. Tidak perlu software atau ekstensi.',
    feature3Title: 'Semua Perangkat',
    feature3Desc: 'Bekerja di Windows, Mac, iPhone, Android dan perangkat apa pun dengan browser.',
    howTo: 'Cara Mengunduh',
    faq: 'FAQ',
    metaDesc: 'Unduh video dari YouTube, Twitter, Instagram, TikTok dan Facebook dalam kualitas HD gratis. Simpan sebagai MP4 atau MP3, hingga resolusi 4K.',
  },
  ms: {
    lang: 'ms',
    title: 'Pemuat Turun Video',
    subtitle: 'Muat turun video dari YouTube, Twitter, Instagram, TikTok dan Facebook dalam HD secara percuma',
    pasteUrl: 'Tampal URL video di sini...',
    paste: 'Tampal',
    download: 'Muat Turun',
    loading: 'Memuatkan...',
    heroText: 'Muat turun video dari YouTube, Twitter, Instagram, TikTok dan Facebook secara percuma.',
    seoTitle: 'Pemuat Turun Video Dalam Talian Percuma',
    seoDesc: 'HD Video Download ialah cara paling mudah untuk memuat turun video dari platform kegemaran anda. Simpan video YouTube dalam kualiti HD sehingga 4K, muat turun video Twitter dan GIF, Instagram Reels, video TikTok tanpa tera air dan video Facebook — semuanya percuma.',
    feature1Title: 'Pelbagai Format',
    feature1Desc: 'Muat turun dalam format video MP4 atau audio MP3. Pilih dari 240p hingga kualiti 4K.',
    feature2Title: 'Tanpa Pemasangan',
    feature2Desc: 'Berfungsi terus dalam pelayar anda. Tidak perlu perisian atau sambungan.',
    feature3Title: 'Semua Peranti',
    feature3Desc: 'Berfungsi di Windows, Mac, iPhone, Android dan mana-mana peranti dengan pelayar.',
    howTo: 'Cara Muat Turun',
    faq: 'Soalan Lazim',
    metaDesc: 'Muat turun video dari YouTube, Twitter, Instagram, TikTok dan Facebook dalam kualiti HD secara percuma. Simpan sebagai MP4 atau MP3, sehingga resolusi 4K.',
  },
  bn: {
    lang: 'bn',
    title: 'ভিডিও ডাউনলোডার',
    subtitle: 'YouTube, Twitter, Instagram, TikTok এবং Facebook থেকে HD ভিডিও বিনামূল্যে ডাউনলোড করুন',
    pasteUrl: 'এখানে ভিডিও URL পেস্ট করুন...',
    paste: 'পেস্ট',
    download: 'ডাউনলোড',
    loading: 'লোড হচ্ছে...',
    heroText: 'YouTube, Twitter, Instagram, TikTok এবং Facebook থেকে বিনামূল্যে ভিডিও ডাউনলোড করুন।',
    seoTitle: 'বিনামূল্যে অনলাইন ভিডিও ডাউনলোডার',
    seoDesc: 'HD Video Download আপনার প্রিয় প্ল্যাটফর্ম থেকে ভিডিও ডাউনলোড করার সবচেয়ে সহজ উপায়। YouTube ভিডিও HD 4K মানে সংরক্ষণ করুন, Twitter ভিডিও এবং GIF, Instagram Reels, ওয়াটারমার্ক ছাড়া TikTok ভিডিও এবং Facebook ভিডিও ডাউনলোড করুন — সব বিনামূল্যে।',
    feature1Title: 'একাধিক ফরম্যাট',
    feature1Desc: 'MP4 ভিডিও বা MP3 অডিও হিসেবে ডাউনলোড করুন। 240p থেকে 4K মান পর্যন্ত বেছে নিন।',
    feature2Title: 'ইনস্টলেশন নেই',
    feature2Desc: 'সরাসরি আপনার ব্রাউজারে কাজ করে। কোনো সফটওয়্যার বা এক্সটেনশন প্রয়োজন নেই।',
    feature3Title: 'সব ডিভাইস',
    feature3Desc: 'Windows, Mac, iPhone, Android এবং ব্রাউজার সহ যেকোনো ডিভাইসে কাজ করে।',
    howTo: 'কিভাবে ডাউনলোড করবেন',
    faq: 'সচরাচর জিজ্ঞাসা',
    metaDesc: 'YouTube, Twitter, Instagram, TikTok এবং Facebook থেকে HD মানে বিনামূল্যে ভিডিও ডাউনলোড করুন। MP4 বা MP3 হিসেবে সংরক্ষণ করুন, 4K পর্যন্ত।',
  },
};

export default translations;
